import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import TextField from "@mui/material/TextField";
import Typography from "@mui/material/Typography";

import { useMemo, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useStyles } from "./styles";
import { resetPassword } from "../../services/sessions";
import { useMutation } from "react-query";
import { useToast } from "../../hooks/useToast";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";

export function ResetPassword() {
  const [password, setPassword] = useState("");
  const [confirmPassword, setConfirmPassword] = useState("");

  const styles = useStyles();
  const navigate = useNavigate();
  const toast = useToast();
  const { token } = useParams();

  const newResetPassword = useMutation(
    async ({ token, password }: { token: string; password: string }) => {
      const response = await resetPassword({ token, password });
      return response;
    },
    {
      onSuccess: () => {
        toast.show("Senha atualizada!", {
          severity: "success",
        });
        navigate("/");
      },
      onError: () => {
        toast.show("Erro ao atualiza senha!", {
          severity: "error",
        });
      },
    }
  );

  const disableButton = useMemo(() => {
    return (
      !password ||
      !confirmPassword ||
      password !== confirmPassword ||
      newResetPassword.isLoading
    );
  }, [password, confirmPassword, newResetPassword.isLoading]);

  async function handleSubmit() {
    await newResetPassword.mutateAsync({
      token,
      password,
    });
  }

  return (
    <Stack spacing={2} alignItems="center">
      <Paper className={styles.paper} elevation={0} variant="outlined">
        <Stack py={2} px={4} spacing={2} alignItems="center">
          <Typography variant="h5">Atualizar senha</Typography>
          <TextField
            size="small"
            type="password"
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="password"
            label="Senha"
            name="password"
            autoComplete="none"
            autoFocus
            value={password}
            onChange={(event) => setPassword(event.target.value)}
          />
          <TextField
            size="small"
            type="password"
            variant="outlined"
            margin="normal"
            required
            fullWidth
            id="password"
            label="Confirme sua Senha"
            name="password"
            autoComplete="none"
            autoFocus
            value={confirmPassword}
            onChange={(event) => setConfirmPassword(event.target.value)}
          />
          <Stack width="100%" direction="row" justifyContent="space-around">
            <Button
              color="primary"
              onClick={() => {
                navigate("/");
              }}
            >
              Cancelar
            </Button>
            <Button
              disabled={disableButton}
              variant="contained"
              color="primary"
              onClick={handleSubmit}
            >
              {newResetPassword.isLoading ? (
                <CircularProgress size={26} color="inherit" />
              ) : (
                "Recuperar"
              )}
            </Button>
          </Stack>
        </Stack>
      </Paper>
    </Stack>
  );
}
